import { interfaces } from '@jarvis/shell-commons';
let manifest = require('./local/manifest.json');
import * as React1 from 'react';
import * as ReactDOM1 from 'react-dom';
import * as VeneerCore from '@veneer/core';
import * as VeneerTokens from '@veneer/tokens';
import * as reactRouterDom from 'react-router-dom';
import Config from '../utils/Config';
import Session from '../utils/Session';
import Debug from '../utils/Debug';
import FT from '../../../common/js/utils/FeatureToggles';
import { navigate } from '../../../common/js/utils/CommonUtils';

const interfacesUtil = {
  getAccessToken: (requestingMFE = 'AdminxOnboarding') => {
    let token;
    switch (requestingMFE) {
      case 'AdminxOnboarding':
        token = {
          adminxToken: localStorage.getItem('adminx__token'),
          duiToken: Session.getToken(),
        };
        break;
      default:
        token = Session.getToken();
    }
    return new Promise((resolve) => {
      resolve(token);
    });
  },
};

const initMFE = (history) => {
  if (System && System.set) {
    // eslint-disable-line no-undef
    System.set('app:react', { __useDefault: true, ...React1 }); // eslint-disable-line no-undef
    System.set('app:react-dom', { __useDefault: true, ...ReactDOM1 }); // eslint-disable-line no-undef
    System.set('app:react-router-dom', { __useDefault: true, ...reactRouterDom }); // eslint-disable-line no-undef
    System.set('app:@veneer/core', { __useDefault: true, ...VeneerCore }); // eslint-disable-line no-undef
    System.set('app:@veneer/tokens', { __useDefault: true, ...VeneerTokens }); // eslint-disable-line no-undef
  }
  return new Promise((resolve, reject) => {
    interfaces._shell
      .init({ manifest, isNpmPackage: true })
      .then(() => {
        window.Shell = interfaces;
        window.Shell.v1.navigation = history;
        window.Shell.v1.commonUtils = { Config, Session, Debug, FT, navigate };
        window.Shell.v1.authProvider.getAccessToken = interfacesUtil.getAccessToken;
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
};

export { initMFE };
